import type { ProgressBarProps as AriaProgressBarProps } from "react-aria-components";
import { ProgressBar as AriaProgressBar } from "react-aria-components";
import { composeTailwindRenderProps } from "./utils";

export interface ProgressBarProps extends AriaProgressBarProps {
  color?: string;
  label?: string;
}

export function ProgressBar(props: ProgressBarProps) {
  return (
    <AriaProgressBar
      {...props}
      className={composeTailwindRenderProps(
        props.className,
        "flex flex-col gap-1",
      )}
    >
      {({ percentage, isIndeterminate }) => (
        <div
          className={`
            relative h-1 w-full overflow-hidden bg-gray-300 outline-1
            -outline-offset-1 outline-transparent
            dark:bg-zinc-700
          `}
        >
          <div
            className={`
              absolute top-0 h-full
              forced-colors:bg-[Highlight]
              ${
                isIndeterminate
                  ? `
            left-full animate-in duration-1000 ease-out repeat-infinite
            slide-in-from-left-[20rem]
          `
                  : `left-0`
              }
            `}
            style={{
              width: `${isIndeterminate ? 40 : percentage}%`,
              backgroundColor: props.color || "black",
            }}
          />
        </div>
      )}
    </AriaProgressBar>
  );
}
